import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.viewLab || initialState;

export const selectLabDetails = createSelector(
  [selectDomain],
  (state) => state.labDetails
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);
